import fetch from 'isomorphic-fetch';

export default class GraphQL {
    getSiteUrl() {
        fetch('/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: `
        {
            generalSettings {
                url
            }
        }
      `,
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                alert(`Site URL is ${res.data.generalSettings.url}`);
            });
    }
}
